import { Routes } from '@angular/router';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';
import { HrDashboardComponent } from './dashboard/hr-dashboard.component';
import { HrDocumentCenterComponent } from './documents/hr-document-center.component';
import { HrDocumentTypeSettingsComponent } from './documents/hr-document-type-settings.component';
import { HrEmployeeDetailComponent } from './employees/hr-employee-detail.component';
import { HrEmployeeFormComponent } from './employees/hr-employee-form.component';
import { HrEmployeeListComponent } from './employees/hr-employee-list.component';
import { HrLifecycleComponent } from './lifecycle/hr-lifecycle.component';
import { HrLeaveComponent } from './leave/hr-leave.component';
import { HrLearningComponent } from './learning/hr-learning.component';
import { HrMigrationComponent } from './migration/hr-migration.component';
import { HrOnboardingComponent } from './onboarding/hr-onboarding.component';
import { HrRecruitmentComponent } from './recruitment/hr-recruitment.component';
import { HrBiometricWorkspaceComponent } from './biometric/hr-biometric-workspace.component';
import { HrWorkforceReadinessComponent } from './readiness/hr-workforce-readiness.component';
import { HrSetupComponent } from './setup/hr-setup.component';
import { HrTimeComponent } from './time/hr-time.component';
import { HrRosterComponent } from './roster/hr-roster.component';
import { HrPayrollComponent } from './payroll/hr-payroll.component';
import { HrCountryPacksComponent } from './country-packs/hr-country-packs.component';
import { HrPerformanceComponent } from './performance/hr-performance.component';
import { HrCasesComponent } from './cases/hr-cases.component';
import { HrAnalyticsComponent } from './analytics/hr-analytics.component';
import { HrAnnualReportComponent } from './analytics/annual-report/hr-annual-report.component';
import { HrAdminOperationsComponent } from './admin-operations/hr-admin-operations.component';

const hrRouteData = {
  enterpriseModules: ['HR'],
  enterpriseFeatureLabel: 'LogiLink HR'
};

export const hrRoutes: Routes = [
  {
    path: 'hr',
    component: HrDashboardComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.dashboard.view,
      scope: 'ANY'
    }
  },
  {
    path: 'hr/employees',
    component: HrEmployeeListComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.employees.view
    }
  },
  {
    path: 'hr/employees/add',
    component: HrEmployeeFormComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.employees.create
    }
  },
  {
    path: 'hr/employees/:id/edit',
    component: HrEmployeeFormComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.employees.edit
    }
  },
  {
    path: 'hr/employees/:id',
    component: HrEmployeeDetailComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.employees.view
    }
  },
  {
    path: 'hr/setup',
    component: HrSetupComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.org.view
    }
  },
  {
    path: 'hr/onboarding',
    component: HrOnboardingComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.onboarding.view
    }
  },
  {
    path: 'hr/recruitment',
    component: HrRecruitmentComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.recruitment.view
    }
  },
  {
    path: 'hr/learning',
    component: HrLearningComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.learning.view
    }
  },
  {
    path: 'hr/labor',
    pathMatch: 'full',
    redirectTo: 'operations/field-work/people'
  },
  {
    path: 'hr/performance',
    component: HrPerformanceComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.performance.view
    }
  },
  {
    path: 'hr/cases',
    component: HrCasesComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.cases.view
    }
  },
  {
    path: 'hr/analytics/annual-report',
    component: HrAnnualReportComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.analytics.view,
      scope: 'ANY'
    }
  },
  {
    path: 'hr/analytics',
    component: HrAnalyticsComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.analytics.view
    }
  },
  {
    path: 'hr/lifecycle',
    component: HrLifecycleComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.lifecycle.view
    }
  },
  {
    path: 'hr/migration',
    component: HrMigrationComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.migration.view
    }
  },
  {
    path: 'hr/documents',
    component: HrDocumentCenterComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.documents.view
    }
  },
  {
    path: 'hr/admin-operations',
    component: HrAdminOperationsComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.adminOperations.view,
      scope: 'ANY'
    }
  },
  {
    path: 'hr/documents/types',
    component: HrDocumentTypeSettingsComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.documentTypes.view
    }
  },
  {
    path: 'hr/readiness',
    component: HrWorkforceReadinessComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.readiness.view
    }
  },
  {
    path: 'hr/leave',
    component: HrLeaveComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.leave.view
    }
  },
  {
    path: 'hr/time',
    component: HrTimeComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.time.view
    }
  },
  {
    path: 'hr/biometric',
    component: HrBiometricWorkspaceComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.biometric.view
    }
  },
  {
    path: 'hr/roster',
    component: HrRosterComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.roster.view
    }
  },
  {
    path: 'hr/payroll',
    component: HrPayrollComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.payroll.view
    }
  },
  {
    path: 'hr/country-packs',
    component: HrCountryPacksComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...hrRouteData,
      permission: app_permissions.hr.countryPacks.view
    }
  },
  ...[
    ['hr/my-profile', 'my-hr/profile'],
    ['hr/my-documents', 'my-hr/documents'],
    ['hr/my-leave', 'my-hr/leave'],
    ['hr/my-timesheets', 'my-hr/timesheets'],
    ['hr/my-payslips', 'my-hr/payslips'],
    ['hr/my-learning', 'my-hr/learning'],
    ['hr/manager/team', 'my-hr/team'],
    ['hr/manager/approvals', 'my-hr/approvals'],
    ['hr/my-hr', 'my-hr']
  ].map(([path, redirectTo]) => ({
    path,
    redirectTo,
    pathMatch: 'full' as const
  }))
];
